import styled from '@emotion/styled';

export const StyledRadioGroup = styled.div`
  color: #999999;
  height: 40px;

  ul {
    display: flex;
    align-items: center;
    height: 40px;
  }
`;

export const StyledRadioTab = styled.div`
  position: relative;
  width: 68px;
  height: 100%;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;

  &:after {
    content: '';
    position: absolute;
    display: none;
    top: 0;
    left: 0;
    width: 67px;
    height: 100%;
    border: 1px solid #2de100;
    box-sizing: border-box;
    z-index: 9;
  }
`;

export const StyledRadio = styled.li`
  height: 40px;

  * + * {
    margin-left: -1px;
  }

  input {
    display: none;

    &:checked + div:after {
      display: block;
    }
  }

  label {
    height: 40px;
    display: block;
    cursor: pointer;
  }
`;
